import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUsername, setEmail, setLoggedIn, setUserId, setPermissions, setSubscription } from '../../redux/userSlice';
import { PrimaryBtn } from '../Assets/Buttons';
import { Field, Label } from '../Assets/Fieldset';
import { Input } from '../Assets/Input';
import { Text, TextLink } from '../Assets/Text';
import { Heading } from '../Assets/Heading';
import { isSubActive } from '../../utils/user';

const SignInForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setFormUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errs, setErrs] = useState("");
  const [validated, setValidated] = useState(false);
  
  const validateForm = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      handleSubmit(event);
    }
    setValidated(true);
  };

  const handleSubmit = async(event) => {
    event.preventDefault();
    
    try{
      const url = `${import.meta.env.VITE_API_URL}/accounts/signin`;
      const body = JSON.stringify({ username, password });
      const options = {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Accept': 'application/json'
          },
          body
      };

      let response = await fetch(url, options);
      let result = await response.json();  

      // Handle sign in errors
      if (!result.ok) {
        handleSignInError(result.error);
        return;
      };

      // Extract Cognito properties and update Redux and indexedDB
      const { userGroups, subscription, userId, email } = result;

      dispatch(setUsername(username));
      dispatch(setUserId(userId));
      dispatch(setEmail(email));
      dispatch(setLoggedIn(true));
      dispatch(setPermissions(userGroups));
          
      console.log(subscription);
      console.log(result);
      // Handle subscription
      handleSubscription(subscription);

    } catch (error) {
      console.error("Sign-in error:", error);
      setErrs("An unexpected error occurred. Please try again.");
    };
  };

  // Function to handle subscription logic and route user
  const handleSubscription = (subscription) => {
    const { userSub } = subscription || {};

    const { isActive, error } = isSubActive(userSub);

    if (error) {
      console.error("Subscription validation error:", error);
    }

    if (!isActive) {
      navigate('/#pricing');
      // After navigation, scroll to pricing section
      setTimeout(() => {
        const element = document.getElementById('pricing');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      return;
    }

    // Dispatch subscription data and isActive status as a single object
    dispatch(setSubscription({ subscription: userSub, isActive }));
    // If we get here, subscription is active
    navigate("/systems");
  };

  // Function to handle authentication errors
  const handleSignInError = (error) => {
    const errorMessage = String(error);
    
    if (errorMessage.includes("NotAuthorizedException: Incorrect username or password.")) {
      setErrs("Incorrect username or password.");
    } else {
      console.error("Authentication error:", errorMessage);
      setErrs("Login failed. Please check your credentials and try again.");
    }
  };

  return (
    <form onSubmit={validateForm} className="grid w-full max-w-sm grid-cols-1 gap-6" noValidate>
      <Heading>Sign in to your account</Heading>
      
      <Field>
        <Label>Username</Label>
        <Input 
          type="text"
          value={username}
          onChange={(e) => setFormUsername(e.target.value)}
          minLength={4}
          required
          aria-invalid={username.length < 4 && validated ? "true" : "false"}
        />
        {username.length < 4 && validated && (
          <Text className="text-brand-red-500 text-sm mt-1">Username must be at least 4 characters.</Text>
        )}
      </Field>
      
      <Field>
        <Label>Password</Label>
        <Input 
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          aria-invalid={password === "" && validated ? "true" : "false"}
        />
        {password === "" && validated && (
          <Text className="text-brand-red-500 text-sm mt-1">Please enter your password.</Text>
        )}
      </Field>
      
      <div className="flex items-center justify-end">
        <TextLink href="/resetpassword" className="text-sm">
          Forgot password?
        </TextLink>
      </div>
      
      {errs && (
        <Text className="text-brand-red-500">{errs}</Text>
      )}
      
      <PrimaryBtn type="submit" className="w-full">
        Sign in
      </PrimaryBtn>
      
      <Text>
        Don't have an account?{' '}
        <TextLink href="/signup">Create one</TextLink>
      </Text>
    </form>
  );
};

export default SignInForm;